import {
    FILTERING_OPERATORS_FOR_STRING,
    JE_WORKSHEET_DASHBOARD_TABLE_COLUMN_NAMES,
    JEWorksheetTableColumns
} from "src/components/jeAllocation/Constants";
import React from "react";
import StringUtils from "src/utils/stringUtils";
import CONSTANTS, {JE_ALLOCATION_STATUS_TO_ICON_TYPE} from "src/utils/constants";
import {Link} from "@amzn/awsui-components-react";
import {StatusIndicator} from "@amzn/awsui-components-react/polaris";

const getCustomPropertiesForWorksheetTableColumnDefinitions = (column: string) => {
    let cell;
    switch (column) {
        case JE_WORKSHEET_DASHBOARD_TABLE_COLUMN_NAMES.WORKSHEET_NAME:
            cell = (e: any) => e.isLinkedWorksheet ?
                <Link href={CONSTANTS.PAGE_NAV.JE_ALLOCATION_LINKED.URL + '/' + window.btoa(e.worksheetId)}>{e[column]}</Link> :
                <Link href={CONSTANTS.PAGE_NAV.JE_ALLOCATION_STANDALONE.URL + '/' + window.btoa(e.worksheetId)}>{e[column]}</Link>
            break;
        case JE_WORKSHEET_DASHBOARD_TABLE_COLUMN_NAMES.LAST_EXECUTED:
            cell = (e: any) => e.lastExecutionTimestamp == null ? "-" : e.lastExecutionTimeDisplay;
            break;
        case JE_WORKSHEET_DASHBOARD_TABLE_COLUMN_NAMES.STATUS:
            cell = (e: any) => e[column] !== "" ? <StatusIndicator
                    type={JE_ALLOCATION_STATUS_TO_ICON_TYPE[e[column]]}> {StringUtils.convertCamelCaseToTitleCase(e[column])} </StatusIndicator> : "";
            break;
        default:
            cell = (e: any) => e[column] ?? "";
    }
    return { cell };
};

export const prepareWorksheetTableColumnDefinitions = () => {
    const columnDefinitions: any[] = [];

    JEWorksheetTableColumns.forEach((column: string) => {
        columnDefinitions.push({
            id: column,
            header: StringUtils.convertCamelCaseToTitleCase(column),
            sortingField: column,
            width: 300,
            ...getCustomPropertiesForWorksheetTableColumnDefinitions(column)
        });
    });
    return columnDefinitions;
};

export const getJEWorksheetDashboardTableFilteringProperties = () => {
    return JEWorksheetTableColumns.map((column: string) => ({
        propertyLabel: StringUtils.convertCamelCaseToTitleCase(column),
        key: column,
        groupValuesLabel: column,
        operators: FILTERING_OPERATORS_FOR_STRING
    }));
}
